import {withComma} from './common';

export const humanizeNumber = (value?: number, smallCut?: boolean) => {
  if (!value) {
    return value;
  }

  const arr = [];

  const signedValue = Math.sign(value);

  if (signedValue === -1) {
    value = Math.round(-1 * value);
  } else {
    value = Math.round(value);
  }

  for (let i = value; i > 0; i = Math.floor(i / 10000)) {
    arr.push(i % 10000);
  }

  let str = '';

  if (arr.length > 3 && arr[3] > 0) {
    str += `${withComma(arr[3])}조 `;
  }
  if (arr.length > 2 && arr[2] > 0) {
    str += `${withComma(arr[2])}억 `;
  }
  if (arr.length > 1 && arr[1] > 0) {
    str += `${withComma(arr[1])}만 `;
  }
  if (!smallCut && arr[0] > 0) {
    str += withComma(arr[0]);
  }

  if (signedValue === 0) {
    return '0';
  } else if (signedValue === 1) {
    return str.trim();
  } else if (signedValue === -1) {
    return `-${str.trim()}`;
  }

  return str.trim();
};
